import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './ProgrammableLogicController.frontend.types'

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_insert_connectorsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { name?: string, type?: string, warehouseId?: number, projectId?: number, orderClassId?: number }): Promise<void> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/functions/insert_connectors`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

